import {type TranslationObject} from '@colonist/i18n'
import {type AjaxDataTypes} from '../../../../shared/AjaxDataTypes.ts'
import {createSpanIn, setElementInnerHTML, setElementOnClick} from '../ui_utils/DomUtils.ts'

export class UIProfileFriendsHorizontalTabsController {
    private readonly horizontalTabsContainer: HTMLDivElement
    private readonly friendsTab: HTMLDivElement
    private readonly friendRequestsTab: HTMLDivElement
    private readonly requestsSentTab: HTMLDivElement

    constructor(userFriendsData: AjaxDataTypes.UserFriendsData) {
        this.horizontalTabsContainer = document.querySelector('.friendspage_friends_tabs_horizontal') as HTMLDivElement
        this.friendsTab = document.getElementById('friendspage_friends_tab') as HTMLDivElement
        this.friendRequestsTab = document.getElementById('friendspage_friendrequests_tab') as HTMLDivElement
        this.requestsSentTab = document.getElementById('friendspage_requestssent_tab') as HTMLDivElement
        const friendsTableWrapper = document.getElementById('friendspage_friends_table_wrapper') as HTMLDivElement
        const friendRequestsTableWrapper = document.getElementById('friendspage_friendrequests_table_wrapper') as HTMLDivElement
        const requestsSentTableWrapper = document.getElementById('friendspage_requestssent_table_wrapper') as HTMLDivElement
        setElementOnClick(this.friendsTab, () => {
            this.highlightTab(this.friendsTab.id)
            friendRequestsTableWrapper.classList.add('hidden')
            requestsSentTableWrapper.classList.add('hidden')
            friendsTableWrapper.classList.remove('hidden')
        })
        setElementOnClick(this.friendRequestsTab, () => {
            this.highlightTab(this.friendRequestsTab.id)
            friendsTableWrapper.classList.add('hidden')
            requestsSentTableWrapper.classList.add('hidden')
            friendRequestsTableWrapper.classList.remove('hidden')
        })
        setElementOnClick(this.requestsSentTab, () => {
            this.highlightTab(this.requestsSentTab.id)
            friendsTableWrapper.classList.add('hidden')
            friendRequestsTableWrapper.classList.add('hidden')
            requestsSentTableWrapper.classList.remove('hidden')
        })

        this.updateCountInTabHeader(userFriendsData)
    }

    updateCountInTabHeader(userFriendsData: AjaxDataTypes.UserFriendsData) {
        UIProfileFriendsHorizontalTabsController.setCountInTabHeader(userFriendsData.friends.length, this.friendsTab)
        UIProfileFriendsHorizontalTabsController.setCountInTabHeader(userFriendsData.friendRequestsReceived.length, this.friendRequestsTab)
        UIProfileFriendsHorizontalTabsController.setCountInTabHeader(userFriendsData.friendRequestsSent.length, this.requestsSentTab)
    }

    static setCountInTabHeader(count: number, headerDiv: HTMLDivElement) {
        setElementInnerHTML(headerDiv, this.getHeaderText(headerDiv))
        if(count > 0) createSpanIn(headerDiv, '', {key: 'strings:colonistCommon.utils.#buffer', options: {value: ` (${count})`}})
    }

    highlightTab(tabId: string) {
        for(const tab of this.horizontalTabsContainer.children) {
            const tabElement = tab as HTMLElement
            if(tabElement.id === tabId) {
                tab.classList.add('active')
            } else {
                tab.classList.remove('active')
            }
        }
    }

    static getHeaderText(headerDiv: HTMLDivElement): TranslationObject {
        switch(headerDiv.id) {
            case 'friendspage_friends_tab':
                return {key: 'strings:profilePage.friends.title'}
            case 'friendspage_friendrequests_tab':
                return {key: 'strings:profilePage.friends.tabs.requests.title'}
            case 'friendspage_requestssent_tab':
                return {key: 'strings:profilePage.friends.tabs.requestsSent.title'}
            default:
                return {key: 'strings:colonistCommon.utils.emptyString'}
        }
    }
}
